<template>
  <v-main>
    <v-container class="fill-height">
      <v-row
        align="center"
        justify="center"
      >
        <v-col
          cols="12"
          sm="8"
          md="6"
          lg="4"
        >
          <v-card class="text-center pa-4" flat>
            <v-icon
              color="warning"
              size="48"
              class="mb-3"
            >
              mdi-lock
            </v-icon>
            <v-card-title class="justify-center text-h5">
              Sidan är begränsad
            </v-card-title>
            <v-card-text>
              Din användarroll har inte behörighet att besöka den här sidan.
              Välj en annan sida i menyn.
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
export default {
  name: 'RestrictedPage'
}
</script>
